module.exports = __webpack_public_path__ + "public/StoreIcon/dlty.svg?dcf68fd8";